import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useKeyTranslations = (key, array) => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    setValues(array.map(item => ({ label: t(`${key}.${item.label}`), value: item.value, text: t(`${key}.${item?.text}`) })));
  }

  return values;
};

export { useKeyTranslations };
